<template>
  <div>
    <div class="search">
      <el-select v-model="searchParams.module" placeholder="请选择模块" clearable>
        <el-option label="设备管理" value="DEVICE"></el-option>
        <el-option label="用户管理" value="USER"></el-option>
        <el-option label="电子围栏" value="GEOFENCE"></el-option>
        <el-option label="短信服务" value="SMS"></el-option>
      </el-select>
      
      <el-select v-model="searchParams.logLevel" placeholder="选择级别" style="width: 120px; margin-left: 10px" clearable>
        <el-option label="信息INFO" value="INFO"></el-option>
        <el-option label="警告WARN" value="WARN"></el-option>
        <el-option label="错误ERROR" value="ERROR"></el-option>
        <el-option label="调试DEBUG" value="DEBUG"></el-option>
      </el-select>
      
      <el-input placeholder="请输入关键词搜索" style="width: 200px; margin-left: 10px" v-model="searchParams.keyword"></el-input>
      
      <el-date-picker
        v-model="searchParams.dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        style="margin-left: 10px; width: 380px"
        value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      
      <el-button type="info" plain style="margin-left: 10px" @click="load(1)">查询</el-button>
      <el-button type="warning" plain style="margin-left: 10px" @click="reset">重置</el-button>
    </div>

    <div class="operation">
      <el-button type="danger" plain @click="delBatch">批量删除</el-button>
      <el-button type="success" plain @click="showStatistics">查看统计</el-button>
      <el-button type="warning" plain @click="showCleanDialog">日志清理</el-button>
      <el-button type="primary" plain @click="exportExcel">导出Excel</el-button>
    </div>

    <div class="table">
      <el-table :data="tableData" stripe @selection-change="handleSelectionChange" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column prop="id" label="序号" width="80" align="center" fixed="left"></el-table-column>
        
        <el-table-column prop="logLevel" label="级别" width="80" align="center">
          <template v-slot="scope">
            <el-tag :type="getLogLevelTagType(scope.row.logLevel)" size="small">
              {{ getLogLevelText(scope.row.logLevel) }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="module" label="模块" width="100"></el-table-column>
        <el-table-column prop="action" label="操作" width="120"></el-table-column>
        <el-table-column prop="userInfo" label="操作用户" width="120"></el-table-column>
        <el-table-column prop="description" label="操作描述" width="200" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="operationResult" label="结果" width="80" align="center">
          <template v-slot="scope">
            <el-tag :type="scope.row.operationResult === 'SUCCESS' ? 'success' : 'danger'" size="small">
              {{ scope.row.operationResult === 'SUCCESS' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="ipAddress" label="IP地址" width="130"></el-table-column>
        <el-table-column prop="executionTimeMs" label="耗时(ms)" width="100" align="center"></el-table-column>
        
        <el-table-column prop="createdAt" label="操作时间" width="170" sortable="custom">
          <template v-slot="scope">
            {{ formatDateTime(scope.row.createdAt) }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template v-slot="scope">
            <el-button size="mini" type="text" @click="showDetail(scope.row)">详情</el-button>
            <el-button size="mini" type="danger" plain @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 日志详情弹窗 -->
    <el-dialog title="日志详情" :visible.sync="detailVisible" width="60%" :close-on-click-modal="false">
      <div v-if="currentLog">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>日志ID：</label>
              <span>{{ currentLog.id }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>日志级别：</label>
              <el-tag :type="getLogLevelTagType(currentLog.logLevel)" size="small">
                {{ getLogLevelText(currentLog.logLevel) }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>模块：</label>
              <span>{{ currentLog.module }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>操作：</label>
              <span>{{ currentLog.action }}</span>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>操作用户：</label>
              <span>{{ currentLog.userInfo || '系统' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>操作结果：</label>
              <el-tag :type="currentLog.operationResult === 'SUCCESS' ? 'success' : 'danger'" size="small">
                {{ currentLog.operationResult === 'SUCCESS' ? '成功' : '失败' }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
        
        <div class="detail-item">
          <label>操作描述：</label>
          <span>{{ currentLog.description }}</span>
        </div>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <label>IP地址：</label>
              <span>{{ currentLog.ipAddress }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <label>执行耗时：</label>
              <span>{{ currentLog.executionTimeMs }} ms</span>
            </div>
          </el-col>
        </el-row>
        
        <div class="detail-item">
          <label>请求URL：</label>
          <span>{{ currentLog.requestUrl }}</span>
        </div>
        
        <div class="detail-item">
          <label>用户代理：</label>
          <span>{{ currentLog.userAgent }}</span>
        </div>
        
        <div class="detail-item" v-if="currentLog.errorMessage">
          <label>错误信息：</label>
          <div class="error-message">{{ currentLog.errorMessage }}</div>
        </div>
        
        <div class="detail-item" v-if="currentLog.detailData">
          <label>详细数据：</label>
          <pre class="detail-data">{{ formatJson(currentLog.detailData) }}</pre>
        </div>
        
        <div class="detail-item">
          <label>操作时间：</label>
          <span>{{ formatDateTime(currentLog.createdAt) }}</span>
        </div>
      </div>
    </el-dialog>

    <!-- 日志清理弹窗 -->
    <el-dialog title="日志清理" :visible.sync="cleanVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="cleanForm" label-width="120px">
        <el-form-item label="清理日期">
          <el-date-picker
            v-model="cleanForm.beforeDate"
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%">
          </el-date-picker>
          <div style="font-size: 12px; color: #999; margin-top: 5px;">
            将删除该日期之前的所有日志记录
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cleanVisible = false">取消</el-button>
        <el-button type="danger" @click="cleanLogs">确认清理</el-button>
      </div>
    </el-dialog>

    <!-- 统计弹窗 -->
    <el-dialog title="日志统计" :visible.sync="statisticsVisible" width="600px" :close-on-click-modal="false">
      <div v-if="statistics">
        <h4>日志级别统计</h4>
        <el-table :data="statistics.levelStats" style="margin-bottom: 20px;">
          <el-table-column prop="logLevel" label="级别">
            <template v-slot="scope">
              <el-tag :type="getLogLevelTagType(scope.row.logLevel)" size="small">
                {{ getLogLevelText(scope.row.logLevel) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
        </el-table>
        
        <h4>模块统计</h4>
        <el-table :data="statistics.moduleStats">
          <el-table-column prop="module" label="模块"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "SystemLog",
  data() {
    return {
      tableData: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,
      searchParams: {
        module: null,
        logLevel: null,
        keyword: null,
        dateRange: [],
        sortField: null,
        sortOrder: null,
      },
      user: JSON.parse(localStorage.getItem('xm-user') || '{}'),
      ids: [],
      detailVisible: false,
      cleanVisible: false,
      statisticsVisible: false,
      currentLog: null,
      cleanForm: {
        beforeDate: null
      },
      statistics: null
    }
  },
  created() {
    this.load(1);
  },
  methods: {
    handleSortChange({ column, prop, order }) {
      this.searchParams.sortField = prop;
      this.searchParams.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : null);
      this.load(1);
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      const date = new Date(dateTimeStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    formatJson(jsonStr) {
      if (!jsonStr) return '';
      try {
        return JSON.stringify(JSON.parse(jsonStr), null, 2);
      } catch (e) {
        return jsonStr;
      }
    },
    getLogLevelTagType(level) {
      const levelMap = {
        'INFO': 'info',
        'WARN': 'warning',
        'ERROR': 'danger',
        'DEBUG': 'success'
      };
      return levelMap[level] || 'info';
    },
    getLogLevelText(level) {
      const levelMap = {
        'INFO': '信息',
        'WARN': '警告',
        'ERROR': '错误',
        'DEBUG': '调试'
      };
      return levelMap[level] || level;
    },
    showDetail(row) {
      this.currentLog = row;
      this.detailVisible = true;
    },
    showCleanDialog() {
      this.cleanForm.beforeDate = null;
      this.cleanVisible = true;
    },
    showStatistics() {
      // 获取统计数据
      const params = {};
      if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
        params.startTime = this.searchParams.dateRange[0];
        params.endTime = this.searchParams.dateRange[1];
      }
      
      Promise.all([
        this.$request.get('/systemLogs/statistics/logLevel', { params }),
        this.$request.get('/systemLogs/statistics/module', { params })
      ]).then(([levelRes, moduleRes]) => {
        this.statistics = {
          levelStats: levelRes.data || [],
          moduleStats: moduleRes.data || []
        };
        this.statisticsVisible = true;
      }).catch(err => {
        this.$message.error('获取统计数据失败');
      });
    },
    cleanLogs() {
      if (!this.cleanForm.beforeDate) {
        this.$message.warning('请选择清理日期');
        return;
      }
      
      this.$confirm('确定要清理该日期之前的所有日志吗？此操作不可恢复！', '确认清理', {
        type: 'warning'
      }).then(() => {
        this.$request.delete('/systemLogs/clean', {
          params: { beforeDate: this.cleanForm.beforeDate }
        }).then(res => {
          if (res.code === '200') {
            this.$message.success(`成功清理 ${res.data} 条日志记录`);
            this.cleanVisible = false;
            this.load(1);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    del(id) {
      this.$confirm('您确定删除这条日志吗？删除后无法恢复。', '确认删除', { type: "warning" }).then(() => {
        this.$request.delete('/systemLogs/delete/' + id).then(res => {
          if (res.code === '200') {
            this.$message.success('操作成功');
            this.load(this.pageNum);
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {});
    },
    handleSelectionChange(rows) {
      this.ids = rows.map(v => v.id);
    },
    delBatch() {
      if (!this.ids.length) {
        this.$message.warning('请选择要删除的日志');
        return;
      }
      this.$confirm(`您确定批量删除选中的 ${this.ids.length} 条日志吗？删除后无法恢复。`, '确认删除', { type: "warning" }).then(() => {
        this.$request.delete('/systemLogs/delete/batch', { data: this.ids }).then(res => {
          if (res.code === '200') {
            this.$message.success('操作成功');
            this.load(1);
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {});
    },
    load(pageNum) {
      if (pageNum) this.pageNum = pageNum;
      
      let startTime = null;
      let endTime = null;
      if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
        startTime = this.searchParams.dateRange[0];
        endTime = this.searchParams.dateRange[1];
      }

      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        module: this.searchParams.module,
        logLevel: this.searchParams.logLevel,
        keyword: this.searchParams.keyword,
        startTime: startTime,
        endTime: endTime,
        sortField: this.searchParams.sortField,
        sortOrder: this.searchParams.sortOrder
      };

      // 清除空值
      for (const key in params) {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key];
        }
      }

      this.$request.get('/systemLogs/selectPage', { params }).then(res => {
        if (res.code === '200') {
          this.tableData = res.data?.list || [];
          this.total = res.data?.total || 0;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.error("Request failed:", err);
        this.$message.error('请求失败: ' + (err.response?.data?.msg || err.message || '未知错误'));
      })
    },
    reset() {
      this.searchParams = {
        module: null,
        logLevel: null,
        keyword: null,
        dateRange: [],
        sortField: null,
        sortOrder: null,
      };
      this.load(1);
    },
    handleCurrentChange(pageNum) {
      this.load(pageNum);
    },
    exportExcel() {
      // 构建导出参数，使用当前的搜索条件
      const params = new URLSearchParams();
      if (this.searchParams.module) {
        params.append('module', this.searchParams.module);
      }
      if (this.searchParams.logLevel) {
        params.append('logLevel', this.searchParams.logLevel);
      }
      if (this.searchParams.keyword) {
        params.append('keyword', this.searchParams.keyword);
      }
      if (this.searchParams.dateRange && this.searchParams.dateRange.length === 2) {
        params.append('startTime', this.searchParams.dateRange[0]);
        params.append('endTime', this.searchParams.dateRange[1]);
      }

      // 创建下载链接
      const exportUrl = `${this.$request.defaults.baseURL}/systemLogs/export?${params.toString()}`;
      
      // 获取用户token
      const user = JSON.parse(localStorage.getItem('xm-user') || '{}');
      if (user.token) {
        // 使用fetch API发送带token的请求
        this.downloadWithAuth(exportUrl, user.token);
      } else {
        this.$message.error('请先登录');
      }
    },
    downloadWithAuth(url, token) {
      fetch(url, {
        method: 'GET',
        headers: {
          'token': token,  // 使用与项目一致的token header名称
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('导出失败');
        }
        
        // 从响应头获取文件名
        const contentDisposition = response.headers.get('content-disposition');
        let fileName = '系统日志.xlsx';
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
          }
        }
        
        return response.blob().then(blob => ({ blob, fileName }));
      })
      .then(({ blob, fileName }) => {
        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        this.$message.success('导出Excel成功');
      })
      .catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出Excel失败: ' + error.message);
      });
    },
  }
}
</script>

<style scoped>
.search {
  margin-bottom: 10px;
}
.operation {
  margin-bottom: 10px;
}
.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.detail-item {
  margin-bottom: 15px;
}
.detail-item label {
  font-weight: bold;
  color: #666;
  display: inline-block;
  width: 100px;
}
.error-message {
  background-color: #fef0f0;
  color: #f56c6c;
  padding: 10px;
  border-radius: 4px;
  border-left: 4px solid #f56c6c;
  margin-top: 5px;
}
.detail-data {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  margin-top: 5px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style> 